import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var OhCrap = function (_a) {
    var error = _a.error, detail = _a.detail;
    return (_jsxs("div", { style: { padding: '24px' }, children: [_jsx("h1", { children: "Oh Crap!" }), _jsxs("p", { children: ["Something went wrong - '", error, "'"] }), detail ? _jsxs("p", { children: ["Reason: ", detail] }) : null, _jsx("p", { children: "'Oh Crap' indeed!" })] }));
};
